import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import { AuthProvider } from './auth/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './styles/theme.css';
import './styles/legacy-palette.css';
import './styles/dash-bridge.css';
import './styles/page-canvas.css';
import './styles/sa-list-page.css';
import './styles/shell.css';
import './styles/project-selection.css';
import App from './App';

document.documentElement.classList.add('app-theme');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>
);
